import React, { Component } from "react";
import parse from "html-react-parser";
import PropTypes from 'prop-types';

class UserBalanceShowModal extends Component {

    render() {
        const {
            modalId = "userBalanceShowModel",
            logoSrc = "images/modal-logo.svg",
            message = "",
            secondaryButtonLabel = "New Application",
            redirectCodeScreen,
            buttonLabel,
            createNewApplication
        } = this.props;

        return (
            <dialog className="modal fade model-error" id={modalId} tabIndex="-1" data-keyboard="false" data-backdrop="static" aria-labelledby={`${modalId}Label`} aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header"></div>
                        <div className="modal-body">
                            <div className="logo">
                                <img src={logoSrc} alt="logo" className="img-fluid" />
                            </div>
                            <p className="text-center mt-4" id="prevamtmsg">
                                {parse(message)}
                            </p>
                        </div>
                        <div className="modal-footer mb-4">
                            <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={(e) => redirectCodeScreen(e)} > {(buttonLabel())}</button>
                            <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={() => { createNewApplication().catch(error => console.error(error)); }}>
                                {secondaryButtonLabel}
                            </button>
                        </div>
                    </div>
                </div>
            </dialog>
        );
    }
}
UserBalanceShowModal.propTypes = {
    modalId: PropTypes.string,
    logoSrc: PropTypes.string,
    message: PropTypes.string,
    secondaryButtonLabel: PropTypes.string,
    redirectCodeScreen: PropTypes.func,
    buttonLabel: PropTypes.func,
    createNewApplication: PropTypes.func
}
export default UserBalanceShowModal;


